import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../store';
import { claimChestReward } from '../../store/reducers/chests/asyncActions';
import { TChestHistoryResponse, TChestRewardHistory } from '../../types';
import ChestSpinnerModal from '../ChestSpinnerModal';
import ReceivedChestRewardModal from '../ReceivedChestRewardModal';

type TSpinAndClaimRewardsProps = {
    chestHistory?: TChestHistoryResponse
    onCollectClose: () => void;
    onSpinEnd?: (reward: TChestRewardHistory) => void;
}

type TModalActiveState<T> = {
    open: true;
    data: T
}

type TModalInactiveState = {
    open: false
}

type TModalState<T> = TModalActiveState<T> | TModalInactiveState

// Close animation takes 500ms to hide modal
const closeDuration = 500;

function SpinAndClaimRewards({ onCollectClose: closeCollectHandler, chestHistory, onSpinEnd }: TSpinAndClaimRewardsProps) {
  const dispatch = useAppDispatch();

  const [chestSpinnerModal, setChestSpinnerModal] = useState<TModalState<TChestHistoryResponse>>({
    open: false,
  });
  const [collectModal, setCollectModal] = useState<TModalState<TChestRewardHistory>>({
    open: false,
  });

  useEffect(() => {
    if (chestHistory?.chest_rewards && chestHistory?.status === 'opened') {
      setCollectModal({ open: true, data: { ...chestHistory.chest_rewards, chest_history_id: chestHistory.id, multiplier: chestHistory.multiplier } });
    } else if (chestHistory?.status === 'owned') {
      setChestSpinnerModal({ open: true, data: chestHistory });
    }

    return () => {
      setCollectModal({ open: false });
      setChestSpinnerModal({ open: false });
    };
  }, [chestHistory]);

  const onCollect = async () => {
    if (!collectModal.open) {
      return;
    }

    await dispatch(claimChestReward({ id: collectModal.data.chest_history_id.toString() }));
    onCollectClose();
  };

  const onCollectClose = () => {
    setCollectModal({ open: false });

    setTimeout(() => {
      setChestSpinnerModal({ open: false });

      setTimeout(() => {
        closeCollectHandler();
      }, closeDuration * 2);
    }, closeDuration);
  };

  const onChestSpinFinish = (reward: TChestRewardHistory) => {
    setCollectModal({ open: true, data: reward });
    onSpinEnd?.(reward);
  };

  return (
    <>
      <ChestSpinnerModal
        chestHistory={chestSpinnerModal.open ? chestSpinnerModal.data : undefined}
        open={chestSpinnerModal.open}
        onFinish={onChestSpinFinish}
      />
      <ReceivedChestRewardModal
        onCollect={onCollect}
        reward={collectModal.open ? collectModal.data : undefined}
        open={collectModal.open}
      />
    </>
  );
}

export default SpinAndClaimRewards;
